export default __webpack_public_path__ + "static/media/menu-meteor-6.123f18ea.png";